import { getScreenType, SCREEN_WIDTH } from "../helpers/layout";

export function HeadlineSmall({children, color, fontWeight = 500, textAlign='justify'}) {
  return (
    <span style={{
      lineHeight: '1.05em',
      // fontFamily: 'Open Sans',
      textAlign,
      fontSize: getScreenType() === SCREEN_WIDTH.COMPACT ? '1.0em' : '1.5em',
      display: 'block',
      color,
      fontWeight,
    }}>{children}</span>
  );
}


/**
 *
 * @param source
 * @param style
 * @param title
 * @param children {JSX.Element}
 * @param radius{number}
 * @param type{'cover' | 'contain' | 'auto'}
 * @returns {JSX.Element}
 * @constructor
 */
export function BackgroundImage(
    {
        source,
        style = {},
        title,
        children,
        radius = 8,
        type = 'cover'
    }
) {
    return (
        <div style={{...style ?? {}, ...{width: '100%', position: 'relative', height: '100%', borderRadius: 8}}}>
            <div
                style={{
                    backgroundImage: `url('${source}')`,
                    backgroundPosition: 'center',
                    backgroundSize: type ?? 'cover',
                    backgroundRepeat: 'no-repeat',
                    height: '100%',
                    width: '100%',
                    borderRadius: radius
                }}
            />
            {(title || children) && <div style={{
                // background: 'linear-gradient(0deg, rgb(0 0 0 / 55%) -5.65%, rgba(0, 0, 0, 0) 52.39%)',
                position: "absolute",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                borderRadius: 8
            }}>
                <div style={{position: "absolute", bottom: 16, left: 16, width: '100%'}}>
                    {children ?? <HeadlineSmall color={"black"}>{title}</HeadlineSmall>}
                </div>
            </div>}
        </div>
    );
}
